module.exports = __webpack_public_path__ + "static/media/close.35f25667.svg";